var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCurrencyEuro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 4233.32 4233.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M1029.39 1509.51c-313.57,0 -676.62,-97.15 -676.62,202.98 0,263.08 173.56,202.99 608.96,202.99l0 405.96c-435.4,0 -608.96,-60.09 -608.96,203 0,300.12 363.05,202.98 676.62,202.98 440.92,833.32 842.47,1217.91 1894.53,1217.91 985.28,0 1163.58,-744.29 744.27,-744.29 -331.13,0 -1237.2,710.07 -2029.84,-473.62 228.22,0 455,4.1 682.47,5.85 758.06,5.85 477.84,-411.83 264.79,-411.83l-1082.59 0 0 -405.96c832.57,0 1285.57,120.15 1285.57,-202.99 0,-261.04 -215.58,-210.79 -467.77,-208.83 -227.47,1.74 -454.25,5.85 -682.47,5.85 1041.82,-1555.84 2232.82,151.54 2232.82,-744.29 0,-393.17 -1338.95,-802.65 -2244.98,-79.81 -311.06,248.15 -412.33,475.47 -596.8,824.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurrencyEuro);
export default __webpack_public_path__ + "static/media/icon-currency-euro.8e8fcfef963a3ce48ab74693a01e4f01.svg";
export { ForwardRef as ReactComponent };